import React, { useContext, useEffect } from "react";
import RegisterNowPay from "./RegisterNowPay/RegisterNowPay";
import "./RegisterLearningDetails.css";
import axios from "axios";
import moment from "moment";
import { Markup } from "interweave";
import { useLocation } from "react-router-dom";
import { useState } from "react";

import { LocationContext } from "../../CustomHelper/Helper";
import Navigation from "../../components/Layouts/Header/Navigation";
import QnADetailsSkeliton from "../Pages/Qna/QnADetailsSkeliton";
import { serverInfo } from "../../App";
import ReactPlayer from "react-player";

const RegisterLearningDetails = (props) => {
  const { paymentCount, paymentCountWithSymbol, payStatus, countryTime, countryDate } =
    useContext(LocationContext);

  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);

  const location = useLocation();
  const [post, setPost] = useState({});

  const [LoadingQnaDetails, setLoadingQnaDetails] = useState([]);
  useEffect(() => {
    const event_id = props.match.params.slug;

    axios.get(`/api/learning-session/${event_id}`).then((res) => {
      if (res.data.status === 200) {
        setPost(res.data.learnigSession);

        setLoadingQnaDetails(false);
      }
    });
  }, [props.match.params.slug]);
  return (
    <>
      <Navigation />
      {LoadingQnaDetails ? (
        <QnADetailsSkeliton />
      ) : (
        <div className="container">
          <div className="mt-3 d-flex justify-content-center card-bg1 p-2">
            {post.banner ? (
              <img
                src={imageCdnUrl + post.banner}
                className="img-fluid"
                alt={imageCdnUrl + post.banner}
              />
            ) : (
              <ReactPlayer
                url={videoCdnUrl + post.video}
                controls={true}
                volume={1}
                width="100%"
                // maxHeight="450px"
                style={{ maxHeight: "450px" }}
              />
            )}
          </div>

          <div className="row mt-3">
            <div className="col-md-12">
              <div className="card card-bg1 shadow">
                <div className="card-body">
                  <h5 className="text-light pb-3 mt-3">{post.title}</h5>

                  <h5 className="text-warning">Instruction</h5>
                  <div className="under-line"></div>
                  <p className="text-light mt-2">
                    <Markup content={post.instruction} />
                  </p>

                  <h5 className="text-warning">Description</h5>
                  <div className="under-line"></div>
                  <p className="text-light mt-2">
                    <Markup content={post.description} />
                  </p>

                  <div className="row">
                    <div className="col-md-3  ">
                      <div className="card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                        <h5 className="text-warning pt-2 ">Star Name</h5>
                        <p className="text-light fw-bold pt-2">
                          {post.star?.first_name} {post.star?.last_name}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-3 ">
                      <div className="card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                        <h5 className="text-warning pt-2 ">Event Date</h5>
                        <p className="text-light fw-bold pt-2">
                          {countryDate(post.event_date)}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-3 ">
                      <div className="card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                        <h5 className="text-warning pt-2 ">Time</h5>
                        <p className="text-light fw-bold pt-2">
                          {countryTime(post?.start_time)}
                          {/* {moment(post.start_time, "HH:mm:ss").format(
                            "hh:mm A"
                            )} */}
                          {" "}
                          -{" "}
                          {countryTime(post?.end_time)}
                          {/* {moment(post.end_time, "HH:mm:ss").format("hh:mm A")} */}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-3 ">
                      <div className="card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                        <h5 className="text-warning pt-2 ">Fee</h5>
                        <p className="text-light fw-bold pt-2">
                          {paymentCountWithSymbol(post.fee)}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {payStatus &&
            <div className="row my-3">
              <div className="col-md-12">
                <div className="card card-bg1 shadow">
                  <div className="card-body">
                    {new Date(moment(post.registration_end_date)).getTime() >
                      new Date().getTime() ? (
                      <RegisterNowPay
                        post={post}
                        fee={paymentCount(post.fee)}
                        baseFee={post.fee}
                        event_type="learningSession"
                        freePayment={post?.fee == 0 ? true : false}
                      />
                    ) : (
                      <div className="text-center my-4">
                        <button className="btn btn-danger mt-3">
                          Registration Time Expired
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          }

        </div>
      )}
    </>
  );
};

export default RegisterLearningDetails;
